import { DESKTOP, useMediaQuery } from '../hooks/useMediaQuery';
import './RecordList.css';
import { focusPageBeforeAction } from './PageStates';

/**
 * #583 S6b1, design §7.6 "mobile table alternative": complete record cards below 1024 px, with a
 * "View table" switch; the captioned table at 1024 px and wider. Exactly one presentation is in
 * the document, and both show every column of every record. Each record's first column is its
 * link, so no row depends on a clickable <tr>.
 *
 * columns: [label, (record) => node][]
 */
/** The page owns the choice, so loading/empty/error transitions cannot reset it. */
export function ViewSwitch({ tableOnNarrow, onChange }) {
  const wide = useMediaQuery(DESKTOP);
  if (wide) return null;
  return (
    <button type="button" className="btn btn-outline view-switch" onClick={() => onChange(!tableOnNarrow)}>
      {tableOnNarrow ? 'View cards' : 'View table'}
    </button>
  );
}

export default function RecordList({ label, caption, columns, records, recordKey, tableOnNarrow }) {
  const wide = useMediaQuery(DESKTOP);
  return (
    <>
      {wide || tableOnNarrow ? (
        <div className="record-table-region" role="region" aria-label={`${label} table`} tabIndex={0}>
          <table className="data-table record-table">
            <caption>{caption}</caption>
            <thead><tr>{columns.map(([name]) => <th key={name} scope="col">{name}</th>)}</tr></thead>
            <tbody>
              {records.map((record) => (
                <tr key={recordKey(record)}>
                  {columns.map(([name, cell], i) => (i === 0
                    ? <th key={name} scope="row">{cell(record)}</th>
                    : <td key={name}>{cell(record)}</td>))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <ul className="record-cards" role="list" aria-label={label}>
          {records.map((record) => (
            <li key={recordKey(record)} className="card">
              <dl>{columns.map(([name, cell]) => <div key={name}><dt>{name}</dt><dd>{cell(record)}</dd></div>)}</dl>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}

/** Page status above two labelled buttons. `disabled` holds both, e.g. while the data is stale. */
export function Pager({ page, pages, disabled, onPage }) {
  return (
    <div className="pagination">
      <span>Page {page} of {pages}</span>
      <div className="pagination-buttons">
        <button type="button" className="btn btn-outline" disabled={disabled || page <= 1} onClick={(event) => { focusPageBeforeAction(event); onPage(page - 1); }}>Previous page</button>
        <button type="button" className="btn btn-outline" disabled={disabled || page >= pages} onClick={(event) => { focusPageBeforeAction(event); onPage(page + 1); }}>Next page</button>
      </div>
    </div>
  );
}
